import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postUser } from '../../services/UsersService';
import { User, PostUserRequest } from '../../types/Users';

type Result = UseMutationResult<User, Error, PostUserRequest>;

function usePostUser(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postUser, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['users-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostUser;
